import { getGlobalProperty } from "@faire/web/common/globals/getGlobalProperty";
import { isPrerender } from "@faire/web/common/user-agent/isPrerender";

export const getIsRobot = (): boolean | undefined =>
  isPrerender() || (getGlobalProperty("isRobot", false) ?? false);
